export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1A0F14] text-white py-16 md:py-20 px-7 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-10 md:gap-12 mb-12 md:mb-16">
          {/* Brand */}
          <div>
            <img
              src="https://storage.readdy-site.link/project_files/d3e20c33-90eb-45ba-8644-8f19c58dcc82/f698c07f-0cab-4570-b763-0881800c24d1_unnamed.png?v=279980a50a992796d79c482ddf8958e7"
              alt="헤라브로우크리닉 로고"
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="font-sans text-sm text-white/60 leading-relaxed mb-4">
              명동 중심의 프리미엄 메디컬 뷰티 클리닉.<br />
              예술적인 문신과 한의학의 정교한 만남.
            </p>
            <p className="font-sans text-xs text-white/40">
              The Artful Union of Tattoo Artistry &amp; Oriental Medicine
            </p>
            <div className="flex gap-3 mt-5">
              <a
                href="tel:01067404061"
                className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-plum rounded-full cursor-pointer transition-colors"
              >
                <i className="ri-phone-fill text-sm"></i>
              </a>
              <a
                href="https://open.kakao.com/o/sFFmWDmi"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-[#FAE100] hover:text-[#3A1D1D] rounded-full cursor-pointer transition-colors"
              >
                <i className="ri-kakao-talk-fill text-sm"></i>
              </a>
              <a
                href="https://line.me/ti/p/5UmAcjQ_dg"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-[#06C755] rounded-full cursor-pointer transition-colors"
              >
                <i className="ri-line-fill text-sm"></i>
              </a>
              <a
                href="https://www.instagram.com/hera__brow"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-gradient-to-br hover:from-[#f09433] hover:to-[#dc2743] rounded-full cursor-pointer transition-colors"
              >
                <i className="ri-instagram-fill text-sm"></i>
              </a>
              <a
                href="https://business.google.com/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-white hover:text-gray-800 rounded-full cursor-pointer transition-colors"
              >
                <i className="ri-google-fill text-sm"></i>
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-serif text-sm font-bold text-gold mb-5 tracking-wider uppercase">서비스 안내</h4>
            <ul className="space-y-2.5">
              {[
                { label: '브랜드 소개', href: '#brand' },
                { label: '반영구 눈썹 문신', href: '#semi-permanent' },
                { label: '안티에이징 레이저', href: '#anti-aging' },
                { label: '다이어트 & 한방 케어', href: '#diet-herbal' },
                { label: '이벤트 가격표', href: '#pricing' },
                { label: '예약 & 오시는 길', href: '#reservation' },
              ].map((item) => (
                <li key={item.href}>
                  <button
                    onClick={() => scrollTo(item.href)}
                    className="font-sans text-sm text-white/60 hover:text-gold transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-sm font-bold text-gold mb-5 tracking-wider uppercase">연락처 & 위치</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2.5">
                <span className="w-4 h-4 flex items-center justify-center text-gold mt-0.5 flex-shrink-0"><i className="ri-map-pin-2-fill text-sm"></i></span>
                <div>
                  <p className="font-sans text-sm text-white/70">서울시 중구 명동3길 5</p>
                  <p className="font-sans text-sm text-white/70">위드빌딩 6층</p>
                  <p className="font-sans text-xs text-white/40">5 Myeongdong 3-gil, Jung-gu, Seoul</p>
                </div>
              </div>
              <div className="flex items-center gap-2.5">
                <span className="w-4 h-4 flex items-center justify-center text-gold flex-shrink-0"><i className="ri-phone-fill text-sm"></i></span>
                <div>
                  <p className="font-sans text-sm text-white/70">010-6740-4061</p>
                </div>
              </div>
              <div className="flex items-center gap-2.5">
                <span className="w-4 h-4 flex items-center justify-center text-gold flex-shrink-0"><i className="ri-time-line text-sm"></i></span>
                <p className="font-sans text-sm text-white/70">매일 11:00 ~ 21:00</p>
              </div>
              <div className="flex items-center gap-2.5">
                <span className="w-4 h-4 flex items-center justify-center text-gold flex-shrink-0"><i className="ri-global-line text-sm"></i></span>
                <p className="font-sans text-sm text-white/70">한 · EN · 中 · 日 상담 가능</p>
              </div>
            </div>
          </div>
        </div>

        {/* Partners */}
        <div className="border-t border-white/10 pt-8 md:pt-10 mb-8 md:mb-10">
          <p className="font-sans text-xs text-white/40 uppercase tracking-widest text-center mb-6">공인 협력 기관 · Official Partners</p>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            {[
              {
                src: 'https://storage.readdy-site.link/project_files/d3e20c33-90eb-45ba-8644-8f19c58dcc82/2c9145de-ae56-4509-afa6-87e2675a758e_unnamed.png?v=6ec4bd8211fc3f4c7551a372b8edf30f',
                alt: '국세청',
                href: 'https://www.nts.go.kr/',
              },
              {
                src: 'https://storage.readdy-site.link/project_files/d3e20c33-90eb-45ba-8644-8f19c58dcc82/90128749-1037-4f0a-bded-ab950904ed7b_unnamed.png?v=5134869b0cd791947c75779171c001ad',
                alt: '사단법인 대한문신사중앙회',
                href: 'https://www.ktf-i.or.kr/',
              },
              {
                src: 'https://storage.readdy-site.link/project_files/d3e20c33-90eb-45ba-8644-8f19c58dcc82/962d0720-4903-444a-857b-2488724262bf_unnamed.png?v=8dba6be99ffe2ca51ca20576aa517958',
                alt: '산업통상자원부',
                href: 'https://www.motie.go.kr/',
              },
              {
                src: 'https://storage.readdy-site.link/project_files/d3e20c33-90eb-45ba-8644-8f19c58dcc82/47ed5bb2-c1c8-46ee-935f-805930f62e0d_unnamed.png?v=542f78edd20dcc237f98201a8859204b',
                alt: '소상공인연합회',
                href: 'https://www.kfme.or.kr/',
              },
            ].map((partner) => (
              <a
                key={partner.alt}
                href={partner.href}
                target="_blank"
                rel="nofollow noopener noreferrer"
                title={partner.alt}
                className="group flex items-center justify-center cursor-pointer px-4 py-2"
              >
                <div
                  className="w-32 h-12 flex items-center justify-center bg-[#1A0F14]"
                  style={{ isolation: 'isolate' }}
                >
                  <img
                    src={partner.src}
                    alt={partner.alt}
                    className="max-w-full max-h-full object-contain opacity-60 group-hover:opacity-100 transition-opacity duration-300"
                    style={{ filter: 'invert(1)', mixBlendMode: 'screen' }}
                  />
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Legal Info + Copyright */}
        <div className="border-t border-white/10 pt-8 md:pt-10 space-y-3">
          <div className="flex flex-wrap justify-center gap-x-5 gap-y-1.5 text-center">
            {[
              { label: '상호명', value: '헤라브로우크리닉' },
              { label: '대표자', value: '김병희' },
              { label: '사업자등록번호', value: '335-71-00681' },
              { label: '주소', value: '서울시 중구 명동3길 5, 위드빌딩 6층' },
              { label: '대표번호', value: '010-6740-4061' },
            ].map((item) => (
              <span key={item.label} className="font-sans text-xs text-white/35">
                <span className="text-white/20">{item.label}</span>
                <span className="mx-1 text-white/15">|</span>
                {item.value}
              </span>
            ))}
          </div>
          <div className="flex flex-col items-center gap-2 sm:flex-row sm:justify-between">
            <p className="font-sans text-xs text-white/30">
              © 2024 헤라브로우크리닉 (Hera Brow Clinic). All rights reserved.
            </p>
            <p className="font-sans text-xs text-white/20">
              대한문신사협회 서울중구지부 · 한의학 박사 상주 · 명동 메디컬 뷰티 클리닉
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
